// extracted by mini-css-extract-plugin
export var filterIncDec = "_c0-0";
export var leftBorder = "_c0-1";
export var rightBorder = "_c0-2";
export var stringInput = "_c0-3";